<template>
	<div class="wrapper">
		<div class="use">
			<div class="content">
				<span class="logo">
					<img src="../assets/logo.png" alt="logo">
				</span>
				<div class="head">
					<header></header>
					<span class="title">{{ticket.ticketName}}</span>
				</div>
				<div class="body">
					<div class="code">
						<div class="tip">券码有效期至{{ticket.expiredDate}},请您尽快完成券码使用,券码超过有效期未使用,服务商无法为您提供换券服务。</div>
						<div class="qrcode" ref="qrCodeUrl"></div>
					</div>
					<div class="sec" v-if="kami === 1">兑换码：{{ticket.outTicketPsw}}
						<button style="margin-left: 10px;background-color: #444444;border-radius: 10px;color: #fff;"
							type="button" v-clipboard:copy="ticket.outTicketPsw" v-clipboard:success="onCopy"
							v-clipboard:error="onError">复制</button>
					</div>
					<div class="sec" v-if="kami === 2">
						<div style="width: 13%;float: left;">&nbsp;<br />&nbsp;</div>
						<div style="text-align: left;">
							<span>卡号：</span>{{ticket.outTicketNumber}}
							<button style="margin-left: 10px;background-color: #444444;border-radius: 10px;color: #fff;"
								type="button" v-clipboard:copy="ticket.outTicketNumber" v-clipboard:success="onCopy"
								v-clipboard:error="onError">复制</button><br />
							<span>卡密：</span>{{ticket.outTicketPsw}}
							<button style="margin-left: 10px;background-color: #444444;border-radius: 10px;color: #fff;"
								type="button" v-clipboard:copy="ticket.outTicketPsw" v-clipboard:success="onCopy"
								v-clipboard:error="onError">复制</button>
						</div>
					</div>
				</div>
				<div class="foot">
					<h1>券码规则</h1>
					<div v-html="ticket.regulation" class="tip"></div>
					<div v-for="item in ticket.supplierProductCaptionList" :key="item.id" class="caption">
						<p v-if="item.showPictureCaptions === 1">{{ item.pictureCaptions }}</p>
						<img v-if="item.imgPath && item.imgPath.length > 0" :src="item.imgPath" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="use_loading" v-if="loading">
			<div class="loading">
				<img src="../assets/loading.png" alt="加载中">
			</div>
		</div>
		<div class="result" v-if="flag">
			<div class="dec">
				<img :src="srcDec" alt="成功">
				<p>{{dec}}</p>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				loading: true,
				key: this.$route.query.key,
				mobile: this.$route.query.mobile,
				name: '',
				effectiveDate: '',
				expiredDate: '',
				ticket: {},
				kami: 1,
				flag: false,
				dec: '',
				srcDec: require('../assets/success.png'),
			}
		},
		mounted() {
			this.getTicket();
		},
		methods: {
			//复制成功的回调
			onCopy: e => {
				alert("复制成功")
			},
			//复制失败的回调
			onError: e => {
				alert("复制失败，请长按文本进行复制")
			},
			getTicket() {
				const obj = {
					ticketNo: this.key,
					isVerify: '-1',
					mobile: this.mobile
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.loading = false;
					console.log(res);
					if (res.code === 0) {
						if (res.data.status == 2 || res.data.status == 3) {
							this.used = true;
						} else {
							this.used = false;
							this.ticket = res.data;
							this.name = this.ticket.ticketName;
							document.title = this.name;
							if (this.ticket.productCategoryList[0].showType === 5) {
								this.kami = 2;
							}
						}

					} else {

					}
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.result {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;

		.dec {
			min-width: 120px;
			height: 120px;
			background: rgba(58, 58, 58, 0.9);
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			border-radius: 2px;
			padding: 0 10px;

			img {
				width: 36px;
				height: 36px;
				font-size: 14px;
			}

			p {
				font-size: 14px;
				color: #fff;
				padding-top: 8px;
			}
		}
	}

	.wrapper {
		height: 100%;
		position: relative;

		.use {
			// height: 100%;
			background: #108EE9;
			padding: 30px 15px 15px 15px;
			box-sizing: border-box;

			.content {
				background: #fff;
				border-radius: 4px;
				background: url('../assets/code_bg.png') #fff center 20px no-repeat;
				background-size: 305px 338px;
				min-height: 338px;
				position: relative;

				.logo {
					position: absolute;
					display: inline-block;
					right: 0;
					top: 0;

					img {
						width: 51px;
						height: 51px;
					}
				}

				.head {
					position: relative;
					height: 30px;
					width: 100%;
					display: flex;
					justify-content: center;

					header {
						width: 190px;
						border-top: 30px solid #2C78DC;
						border-right: 12px solid transparent;
						border-left: 12px solid transparent;
						box-sizing: border-box;
						height: 30px;
					}

					.title {
						font-size: 15px;
						position: absolute;
						top: 0;
						left: 0;
						color: #fff;
						width: 100%;
						height: 30px;
						line-height: 30px;
						text-align: center;
					}
				}

				.body {
					border-bottom: 1px dashed #CCCCCC;

					p {
						font-size: 15px;
						color: #999999;
						text-align: center;
						padding-top: 10px;
					}

					h1 {
						font-size: 20px;
						color: #333333;
						text-align: center;
						padding-top: 15px;
					}

					.code {
						padding-top: 40px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;

						.qrcode {
							padding-top: 20px;
						}

						.tip {
							width: 75%;
							background: yellow;
							font-size: 12px;
						}
					}

					.sec {
						font-size: 15px;
						color: #F76A24;
						padding: 30px 0 15px 0;
						text-align: center;
						font-weight: bold;
						font-size: 16px;
					}

					.dec {
						font-size: 15px;
						background: #FEFCEC;
						padding: 10px 0;
						color: #F76A24;
						text-align: center;
					}

					.btn {
						display: flex;
						justify-content: center;
						padding: 15px 0 30px 0;

						.button {
							font-size: 15px;
							width: 200px;
							height: 40px;
							line-height: 40px;
							text-align: center;
							color: #fff;
							background: #1E87FC;
							border-radius: 4px;
						}
					}
				}

				.foot {
					padding: 24px 17px;

					h1 {
						font-size: 20px;
						color: #333333;
						font-weight: bold;
					}

					.tip {
						color: #666666;
						font-size: 15px;
						line-height: 28px;
					}

					.caption {
						img {
							max-width: 100%;
							padding: 5px 0;
						}

						p {
							color: #666666;
							font-size: 15px;
							line-height: 28px;
						}
					}
				}
			}
		}

		.use_loading {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 11;
			left: 0;
			top: 0;

			.loading {
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50px;
					height: 50px;
					animation: turn .8s linear infinite;
					margin: 100px auto;
				}

				@keyframes turn {
					0% {
						-webkit-transform: rotate(0deg);
					}

					25% {
						-webkit-transform: rotate(90deg);
					}

					50% {
						-webkit-transform: rotate(180deg);
					}

					75% {
						-webkit-transform: rotate(270deg);
					}

					100% {
						-webkit-transform: rotate(360deg);
					}
				}
			}
		}
	}
</style>
